<template lang="html">
  <v-container>
    <v-layout row>
      <v-flex>
        <img :src="requireImg()">
      </v-flex>
      <v-flex>
        <p>
          {{$t('gif.TEXT')}}
        </p>
      </v-flex>
    </v-layout>
  </v-container>

</template>

<script>
export default {
  methods: {
    requireImg(){
      const lang = navigator.language.slice(0, 2)
      const img = require('../../public/img/gif/' + lang + '_Beta Digitis - Gif.gif')
      if(img) return img
      else return require('../../public/img/gif/en_Beta Digitis - Gif.gif')
    }
  }
}
</script>

<style lang="css" scoped>
</style>
